import { Link } from "react-router-dom";

import { Compass } from "lucide-react";

import { Button } from "@/shared/components/ui/button";

export function NotFoundPage() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-4 bg-arya-bg px-4 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-muted text-muted-foreground">
        <Compass className="h-7 w-7" />
      </div>
      <div>
        <h1 className="text-2xl font-semibold">Página no encontrada</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          La ruta que buscas no existe o ya no está disponible.
        </p>
      </div>
      <Button asChild>
        <Link to="/">Volver al inicio</Link>
      </Button>
    </div>
  );
}
